import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
const OrderConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState(null);

  useEffect(() => {
    // Fetch order details using orderId from location state
    const fetchOrderDetails = async () => {
      try {
        const response = await fetch(`/api/orders/${location.state.orderId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        const data = await response.json();
        setOrderDetails(data);
      } catch (error) {
        console.error('Error fetching order details:', error);
      }
    };

    if (location.state?.orderId) {
      fetchOrderDetails();
    }
  }, [location.state]);

  const getOrderDate = () => {
    if (!orderDetails) return '';
    return new Date(orderDetails.orderDate).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2">
        <div className="container">
          <div className="breadcrumb-title">
            <h2>OrderConfirmation</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">Home </Link></li>
              <li>OrderConfirmation</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          {/* Success Message */}
          <div className="text-center mb-12">
            <div className="mb-4">
              <div className="h-16 w-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <Check className="h-8 w-8 text-green-600" />
              </div>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Order Confirmed!</h1>
            <p className="text-gray-600">Thank you for your order. We've received your payment.</p>
          </div>

          {/* Order Details Card */}

          {/* Customer Support */}
          <div className="text-center text-sm text-gray-600">
            <p>Need help? Contact our customer support</p>
            <p className="font-medium">support@example.com | +1 234 567 890</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderConfirmation;